<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6xz3cd/tc-custom/9781451621730.jpg?1730517608401" alt="This image is the cover for the book How to Enjoy Your Life and Your Job"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Enjoy Your Life and Your Job
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn how to uncover your hidden assets with timeless advice from <i>How to Win Friends and Influence People </i>and <i>How to Stop Worrying and Start Living</i>.</b><br/><br/>Even if you love your work, you probably have days when almost nothing goes right. Bestselling author Dale Carnegie shows you how to make every day more exciting and rewarding—how you can get more done, and have more fun doing it. Dale Carnegie’s time-tested advice will help you to:Make other people feel important—and do it sincerelyAvoid unnecessary tension—save your energy for important dutiesGet people to say yes—immediatelyTurn routine tasks into stimulating opportunitiesSpot a sure-fire way of making enemies—and avoid itSmile in the face of criticism—you’ve done your very best!<br/><br/><i>How to Enjoy Your Life and Your Job</i> will help you create a new approach to life and people and discover talents you never knew you had. Dale Carnegie can help you get the most out of yourself—all the time. Start developing your innate strengths and abilities—start enriching your life TODAY!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dale Carnegie
      </h2>
      
      <p class="authorDescription body article">Dale Carnegie (1888&ndash;1955) was an American writer and lecturer and the developer of famous courses in self-improvement, salesmanship, corporate training, public speaking, and interpersonal skills. Born in poverty on a farm in Missouri, he was the author <I>of How to Win Friends and Influence People</I>, first published in 1936, a massive bestseller that remains popular today. He also wrote a biography of Abraham Lincoln, titled <I>Lincoln the Unknown</I>, as well as several other books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38da5be6